import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LeftWizard from "./LeftWizard";
import getPlatformType from "../../../../helpers/helpers";


const layoutType = getPlatformType(); // "web" | "ios" | "android"

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
  },

  container: {
    width: "100%",
    background: "#fff",
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 10px 35px rgba(0,0,0,0.08)",
  },

  header: {
    padding: "10px 20px",
    borderBottom: "1px solid #e5e5e5",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  headerTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: "#9C6CFF",
  },

  closeBtn: {
    fontSize: 14,
    fontWeight: 600,
    color: "#444",
    cursor: "pointer",
    "&:hover": { opacity: 0.7 },
  },

  // Desktop Layout — Wizard on LEFT
  bodyDesktop: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    width: "100%",
    overflow: "hidden",
    alignItems: "stretch",
  },

  // Mobile Layout — Wizard on TOP
  bodyMobile: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflow: "hidden",
  },

  // Wizard Panel (Desktop)
  leftPanelDesktop: {
    width: "27%",
    minWidth: 220,                 // *** FIX ***
    borderRight: "1px solid #E4E0F3",
    whiteSpace: "nowrap",          // Prevent text collapsing
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex",
    flexDirection: "column",
  },

  // Wizard Panel (Mobile)
  leftPanelMobile: {
    width: "100%",
    borderBottom: "1px solid #E4E0F3",
    paddingBottom: 8,
  },

  rightPanel: {
    flex: 1,
    padding: "10px 10px",
    boxSizing: "border-box",
    overflowY: "auto",
  },

  footer: {
    padding: "10px 20px",
    borderTop: "1px solid #eee",
    background: "#f9f9f9",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  prevBtn: {
    background: "#E4E4E4",
    height: 36,
    color: "#555",
    padding: "12px 24px",
    borderRadius: 6,
    fontWeight: 600,
    "&:hover": { background: "#d6d6d6" },
  },

  nextBtn: {
    height: 36,
    background: "#9C6CFF",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: 6,
    fontWeight: 600,
    "&:hover": { background: "#8755e8" },
  },
}));

const DepositWizard = ({
  steps,
  activeStep,
  onNext,
  onPrev,
  onClose,
  children,
}) => {
  const classes = useStyles();
  const isMobile = layoutType !== "web";

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.container}>

        {/* HEADER */}
        <Box className={classes.header}>
          <Typography className={classes.headerTitle}>
            {steps[activeStep]?.subLabel || "Deposit details"}
          </Typography>
          <Typography onClick={onClose} className={classes.closeBtn}>
            CLOSE
          </Typography>
        </Box>

        {/* BODY */}
        <Box className={isMobile ? classes.bodyMobile : classes.bodyDesktop}>
          
          {/* LEFT WIZARD */}
          <Box
            className={
              isMobile ? classes.leftPanelMobile : classes.leftPanelDesktop
            }
          >
            <LeftWizard steps={steps} activeStep={activeStep} />
          </Box>

          {/* RIGHT PANEL */}
          <Box className={classes.rightPanel}>{children}</Box>
        </Box>

        {/* FOOTER NAVIGATION */}
        <Box className={classes.footer}>
          <Button
            disabled={activeStep === 0}
            onClick={onPrev}
            className={classes.prevBtn}
          >
            PREVIOUS
          </Button>

          <Button
            disabled={activeStep === steps.length - 1}
            onClick={onNext}
            className={classes.nextBtn}
          >
            NEXT
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DepositWizard;
